import { Link, graphql, useStaticQuery } from "gatsby";
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import React, { useRef } from "react";
import { useInViewport } from 'react-in-viewport';
import * as s from "./footer.module.css";

const Footer = () => {

  const blockRef = useRef();
  const { enterCount } = useInViewport(blockRef, {}, { disconnectOnLeave: false }, {});

  const { wp: { acfOptionsFooter: { footer: { footerSocials } } } } = useStaticQuery(graphql`
    query MyOptionsFooterQuery {
      wp {
        acfOptionsFooter {
          footer {
            footerSocials {
              icon {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(quality: 100)
                  }
                }
              }
              link {
                url
                title
                target
              }
            }
          }
        }
      }
    }
  `);

  const bp = useBreakpoint();

  const [opened, setOpened] = React.useState({
    products: false,
    customers: false,
    resources: false,
    company: false,
  });

  const toggleOpened = (key) => {
    let newOpened = { ...opened };
    newOpened[key] = !opened[key];
    setOpened(newOpened);
  }


  return (
    <>
      <footer className="d-flex ttt" ref={blockRef}>
        {enterCount > 0 &&
          <div className="container">
            <div className="row mb-3 pb-3">
              <div className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-start align-items-start">
                <StaticImage
                  loading="eager"
                  placeholder="none"
                  alt="Orders.co logo"
                  height={70}
                  width={289}
                  src="../../../images/logo-footer.png"
                  className={`${s.footerLogo} ml-3 mb-3 mt-4`}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  className={
                    s.footerMenus +
                    " d-flex justify-content-around justify-content-lg-start flex-wrap flex-xxl-nowrap"
                  }
                >
                  <div className={`${s.footerMenu} col`}>
                    <div className={s.footerMenuTitle} onClick={() => { toggleOpened('products') }}>Product</div>
                    <ul className={`${opened.products ? s.opened : ''} d-flex flex-column`}>
                      <li className={s.menuItem}>
                        <Link to="/features-overview/">Features Overview</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/restaurant-menu-management/">Menu Management</Link>
                      </li>
                      <li className={`${s.menuItem}`}>
                        <Link to="/restaurant-orders-consolidation/">
                          Orders Consolidation
                        </Link>
                      </li>
                      <li className={`${s.menuItem}`}>
                        <Link to="/restaurant-custom-ordering-website/">
                          Custom Ordering Website
                        </Link>
                      </li>
                      <li className={`${s.menuItem}`}>
                        <Link to="/restaurant-qr-menu-maker/">
                          QR Menu Maker
                        </Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/restaurant-reporting/">Reporting</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/integrations/">Integrations</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/pricing/">Pricing</Link>
                      </li>
                      {!bp?.md && <>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-ai-website-builder/">AI Website Builder</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-dispute-management-assistant/">Dispute Management Assistant</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-marketing-solutions/">Marketing Solutions (Powered By AI)</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-local-business-optimization/">Local Business Optimization (SEO)</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-loyalty-reward-program/">Loyalty Reward Program</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-guest-feedback-monitoring/">Guest Feedback Monitoring</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-dine-in-ordering/">Dine-In Ordering</Link>
                        </li>
                      </>}
                    </ul>
                  </div>
                  {bp?.md &&
                    <div className={`${s.footerMenu} col`} style={{ minWidth: '330px' }}>
                      <div className={s.footerMenuTitle}>&nbsp;</div>
                      <ul className={`${opened.customers ? s.opened : ''} d-flex flex-column`}>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-ai-website-builder/">AI Website Builder</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-dispute-management-assistant/">Dispute Management Assistant</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-marketing-solutions/">Marketing Solutions (Powered By AI)</Link>
                        </li>
                        <li className={s.menuItem}>
                          <Link to="/restaurant-local-business-optimization/">Local Business Optimization (SEO)</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-loyalty-reward-program/">Loyalty Reward Program</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-guest-feedback-monitoring/">Guest Feedback Monitoring</Link>
                        </li>
                        <li className={`${s.menuItem}`}>
                          <Link to="/restaurant-dine-in-ordering/">Dine-In Ordering</Link>
                        </li>
                      </ul>
                    </div>
                  }
                  <div className={`${s.footerMenu} col`}>
                    <div className={s.footerMenuTitle} onClick={() => { toggleOpened('customers') }}>Customers</div>
                    <ul className={`${opened.customers ? s.opened : ''} d-flex flex-column`}>
                      <li className={s.menuItem}>
                        <Link to="/customer-stories/">Customer Stories</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/independent-restaurants/">
                          Independent Restaurants
                        </Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/chain-restaurants/">Chain Restaurants</Link>
                      </li>
                      <li className={`${s.menuItem}`}>
                        <Link to="/franchise/">Franchise</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/ghost-kitchen/">Ghost Kitchen</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/q-commerce/">Q-commerce</Link>
                      </li>
                    </ul>
                  </div>
                  <div className={`${s.footerMenu} col`}>
                    <div className={s.footerMenuTitle} onClick={() => { toggleOpened('resources') }}>Resources</div>
                    <ul className={`${opened.resources ? s.opened : ''} d-flex flex-column`}>
                      <li className={s.menuItem}>
                        <Link to="/blog/">Blog</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/frequently-asked-questions/">FAQ</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/privacy-policy/">Privacy Policy</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/terms-of-use/">Terms of Use</Link>
                      </li>
                    </ul>
                  </div>
                  <div className={`${s.footerMenu} col`}>
                    <div className={s.footerMenuTitle} onClick={() => { toggleOpened('company') }}>Company</div>
                    <ul className={`${opened.company ? s.opened : ''} d-flex flex-column`}>
                      <li className={s.menuItem}>
                        <Link to="/about-us/">About Us</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/contact-us/">Contact Us</Link>
                      </li>
                      <li className={s.menuItem}>
                        <Link to="/partner-with-us/">Partner With Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
            <div className="row mt-lg-5">
              <div className="col-lg-3 order-lg-2 mb-5 mb-lg-0">
                <div className="d-flex flex-column align-items-center align-items-lg-end h-100 w-100" style={{ gap: '24px' }}>
                  <a href="mailto:hello@orders.co" className="d-flex flex-column flex-lg-row align-items-center" style={{ color: '#1C1B1C', gap: '10px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M4.07187 20.2031C3.44221 20.2031 2.90562 19.9814 2.46213 19.5379C2.01863 19.0944 1.79688 18.5578 1.79688 17.9281V6.07163C1.79688 5.44196 2.01863 4.90538 2.46213 4.46188C2.90562 4.01838 3.44221 3.79663 4.07187 3.79663H19.9284C20.558 3.79663 21.0946 4.01838 21.5381 4.46188C21.9816 4.90538 22.2034 5.44196 22.2034 6.07163V17.9281C22.2034 18.5578 21.9816 19.0944 21.5381 19.5379C21.0946 19.9814 20.558 20.2031 19.9284 20.2031H4.07187ZM12.0001 13.2569L19.9284 8.25688V6.07163L12.0001 11.0716L4.07187 6.07163V8.25688L12.0001 13.2569Z" fill="#1C1B1C" />
                    </svg>
                    <span>hello@orders.co</span>
                  </a>
                  <a href="tel:18555001070" className="d-flex flex-column flex-lg-row align-items-center" style={{ color: '#1C1B1C', gap: '10px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path d="M19.9639 21.4056C17.8566 21.4056 15.7744 20.9465 13.7172 20.0281C11.6599 19.1098 9.78594 17.8074 8.09544 16.1209C6.40477 14.4302 5.10035 12.5553 4.18219 10.4961C3.26385 8.43698 2.80469 6.35373 2.80469 4.2464C2.80469 3.89056 2.9226 3.59373 3.15844 3.3559C3.39427 3.11806 3.6901 2.99915 4.04594 2.99915H8.08994C8.41494 2.99915 8.69302 3.09523 8.92419 3.2874C9.15535 3.47956 9.2996 3.7259 9.35694 4.0264L10.0009 7.40065C10.0501 7.72715 10.0428 8.00398 9.97894 8.23115C9.91494 8.45831 9.79235 8.65648 9.61119 8.82565L7.15019 11.2279C7.46769 11.8007 7.8436 12.3587 8.27794 12.9019C8.71244 13.4451 9.19669 13.9753 9.73069 14.4926C10.2275 14.9893 10.7394 15.4446 11.2662 15.8584C11.7929 16.2722 12.345 16.6465 12.9227 16.9811L15.3144 14.6074C15.5083 14.4174 15.7459 14.281 16.0274 14.1981C16.3089 14.1151 16.5963 14.0982 16.8894 14.1474L20.1779 14.8296C20.4951 14.9201 20.7456 15.0738 20.9294 15.2906C21.1133 15.5075 21.2052 15.7661 21.2052 16.0666V20.1584C21.2052 20.5142 21.0863 20.8111 20.8484 21.0489C20.6106 21.2867 20.3158 21.4056 19.9639 21.4056Z" fill="#1C1B1C" />
                    </svg>
                    <span>1-855-500-1070</span>
                  </a>
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className={
                    s.footerSocials + " d-flex justify-content-center justify-content-lg-start col"
                  }
                >
                  {footerSocials?.map((s, i) => {
                    const icon = {
                      data: s?.icon?.localFile?.childImageSharp?.gatsbyImageData,
                      alt: s?.icon?.altText || ``,
                    };
                    return <Link
                      to={s?.link?.url}
                      className="d-inline-flex mr-2"
                      target={s?.link?.target}
                      rel="noreferrer"
                      key={i}
                    >
                      <GatsbyImage
                        placeholder="none"
                        loading="eager"
                        image={icon.data}
                        alt={icon.alt}
                        className="mw-100" />
                    </Link>
                  })}
                </div>
                <div className="col d-flex flex-wrap flex-lg-nowrap justify-content-center justify-content-lg-between align-items-center">
                  <div className={s.footerCopyright + " text-center text-lg-left"}>
                    Copyright © {(new Date().getFullYear())} | Orders.co an "Orders Grid" Company | All Rights
                    Reserved
                  </div>
                </div>
              </div>

            </div>
          </div>
        }
      </footer>
    </>
  );
};

export default Footer;
